<template>
  <b-sidebar id="add-edit-category-sidebar" :visible="isAddEditCategorySidebarActive" bg-variant="white"
    sidebar-class="sidebar-lg" shadow backdrop no-header right @hidden="resetForm"
    @change="(val) => $emit('update:is-add-edit-category-sidebar-active', val)">
    <template #default="{ hide }">
      <!-- Header -->
      <div class="
          d-flex
          justify-content-between
          align-items-center
          content-sidebar-header
          px-2
          py-1
        ">
        <h5 class="mb-0">Edit Topics</h5>

        <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="hide" />
      </div>

      <!-- BODY -->
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <!-- Form -->
        <b-form class="p-2" @submit.prevent="handleSubmit(onSubmit)" @reset.prevent="resetForm">
          <!-- Full Name -->

          <validation-provider #default="validationContext" name="Topic Name" rules="required">
            <b-form-group label="Topic Name" label-for="Topic Name">
              <b-form-input id="Edit-Category" v-model="CategoryData.category_name" autofocus
                :state="getValidationState(validationContext)" trim />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <validation-provider #default="validationContext" name="Sort Category" rules="required">
            <b-form-group label="Sort Category" label-for="Sort Category">
              <b-form-input id="Sort-Category" v-model="CategoryData.order" autofocus
                :state="getValidationState(validationContext)" trim type="number" placeholder="Enter Numeric Value" />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <div class="mb-3">
            <label class="d-block">Show Tilte</label>
            <b-form-checkbox
              v-model="CategoryData.showTitle"
              switch
              size="lg"
            >
              <!-- {{ category_data.publicAccess ? 'Public' : 'Private' }} -->
            </b-form-checkbox>
          </div>

          <validation-provider name="Description">
            <b-form-group label="Description" label-for="Topic-Description">
              <b-form-textarea
                id="Topic-Description"
                v-model="CategoryData.description"
                rows="4"
                max-rows="6"
              />
            </b-form-group>
          </validation-provider>
          <br />

          <template v-if="getFileExtensionFromUrl(CategoryData.category_img) == 'json'">
            <LottieView :url="CategoryData.category_img" :forEditTopics="true" :key="keyForLottie" />
          </template>
          <template v-else-if="getFileExtensionFromUrl(CategoryData.category_img) == 'lottie'">
            <DoLottieView :url="CategoryData.category_img" :forEditTopics="true" 
            :id="`topic_image_${uuidv4()}`"  :key="keyForLottie" />
          </template>

          <template v-else>
            <img style="width: 200px; height: 150px" :src="CategoryData.category_img" />
          </template>
          <br />
          <br />
          <b-button variant="primary" @click="showgalleryimage">
            <!-- <input
              ref="refInputEl"
              type="file"
              class="d-none"
              @input="inputImageRenderer"
            /> -->
            <span class="d-none d-sm-inline">Images gallery</span>
            <!-- <feather-icon icon="EditIcon" class="d-inline d-sm-none" /> -->
          </b-button>
          <b-button style="margin-left: 10px" variant="primary" @click="$refs.refInputEl.click()">
            <input ref="refInputEl" type="file" class="d-none" @input="inputImageRenderer" />
            <span class="d-none d-sm-inline">Upload</span>
            <feather-icon icon="EditIcon" class="d-inline d-sm-none" />
          </b-button>

          <zape-gallery-model :props_hideShowModel="showImage" @modelClose="modelClose"
            @saveCategoryImage="saveCategoryImage" :keyForLottie="keyForLottie" />
          <!-- <br />
          <br /> -->
          <div style="height: 200px !important; display: flex; align-items: center; margin-bottom: 40px;">
            <img style="width: 150px; height: 120px" v-if="CategoryData.video == null"
              src="https://zape02.s3.ap-southeast-1.amazonaws.com/0.76871584038628660.98656671003321120.19322443436631032.png" />
            <div style="width: 150px; height:   120px; object-fit: contain;"
              v-if="CategoryData.video != null && CategoryData.video.video_uri">
              <span v-if="isM3U8(CategoryData.video.video_uri)">
                        <HLSPlayer
                          :src="CategoryData.video.video_uri"
                          :poster="CategoryData.video.videoThumbnail"
                        />
                        </span>
                        <span v-else>
              <b-embed type="video" aspect="4by3" controls :poster="CategoryData.video.videoThumbnail">
                <source :src="CategoryData.video.video_uri" type="video/webm" />
                <source :src="CategoryData.video.video_uri" type="video/x-m4v" />
                <source :src="CategoryData.video.video_uri" type="video/mp4" />
                <source :src="CategoryData.video.video_uri" type="video/avi" />
              </b-embed>
            </span>
            </div>

            <b-button variant="primary" @click="showVideosModel" class="m-1">
              <span class="d-none d-sm-inline">Select</span>
            </b-button>
            <!-- <br />
            <br /> -->
          </div>

          <zape-video-model :props_hideShowModel="statusVideosModel" @modelClose="modelVideoClose"
            @saveCategoryVideo="saveCategoryVideo" />

          <div class="d-flex bg-light text-light align-items px-3 py-2"
            style="position: absolute; bottom: 0%; left: 0%; width: 100%">
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" type="submit" @click="hide"
              :disabled="submitbutton">
              update
            </b-button>
            <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" type="button" style="margin-left: 10px"
              variant="outline-secondary" @click="hide">
              Cancel
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>


<script>
import {
  BSidebar,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
  BFormFile,
  BCol,
  BEmbed,
  BFormCheckbox,

} from "bootstrap-vue";
import { BFormTextarea } from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { ref } from "@vue/composition-api";
import { required, alphaNum, email } from "@validations";
import formValidation from "@core/comp-functions/forms/form-validation";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import countries from "../../../../@fake-db/data/other/countries";
import store from "@/store";
import axios from "axios";
import S3 from "aws-s3";
import ZapeGalleryModel from "../../../components/Model/ZapeGalleryModel.vue"
import ZapeVideoModel from "../../../components/Model/ZapeVideoModel.vue"
import LottieView from "@/views/components/question/LottieView.vue";
import DoLottieView from "@/views/components/question/DoLottieView.vue";
import { v4 as uuidv4 } from 'uuid';
import HLSPlayer from '@/views/HLSPlayer.vue';

export default {
  components: {
    ZapeVideoModel,
    ZapeGalleryModel,
    BSidebar,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,
    BFormFile,
    ValidationProvider,
    ValidationObserver,
    BEmbed,
    LottieView,
    DoLottieView,
    uuidv4,
    BFormTextarea,
    BFormCheckbox,
    HLSPlayer,


  },
  directives: {
    Ripple,
  },
  model: {
    prop: "isAddEditCategorySidebarActive",
    event: "update:is-add-edit-category-sidebar-active",
  },
  props: {
    isAddEditCategorySidebarActive: {
      type: Boolean,
      required: true,
    },
    EditModuleData:{
      type: Object,
      required: true,
    },
    
  },
  watch: {
    isAddEditCategorySidebarActive(val){
      if(val){
        // console.log("value++++++++++++++++++++",description)
        const {categoryImg, categoryName, categoryVideo ,description, showTitle,  module = null,subjectId , _id ,order} = JSON.parse(JSON.stringify(this.EditModuleData))
        // console.log(categoryImg, categoryName,showTitle, _id, module?._id || 'No Module')
        console.log("value++++++++++++++++++++",description)
        this.CategoryData.category_name = categoryName
        this.CategoryData.category_img  = categoryImg
        this.CategoryData.video = categoryVideo
        this.CategoryData.description = description ?? null
        console.log("value++++++++++++++++++++",this.CategoryData.description )

        this.CategoryData.module = module ?? { _id: null, module_name: "No Module" }
        this.CategoryData.category_id = _id
        this.CategoryData.subject_id = subjectId
        this.CategoryData.order = order
        this.CategoryData.showTitle = showTitle
        console.log("value",this.CategoryData.showTitle)


      }


    },

    // Editcategoryname() {
    //   this.CategoryData.category_name = this.Editcategoryname;
    // },
    // editOrder() {
    //   this.CategoryData.order = this.editOrder;
    // },
    // EditCategoryImage() {
    //   this.CategoryData.category_img = this.EditCategoryImage;
    // },
    // EditCategoryVideo() {
    //   this.CategoryData.video = this.EditCategoryVideo;
    // },
    // EditDescriptionData(description) {
    //   this.CategoryData.description = description;
    // },
    // EditModuleData(module) {
    // this.CategoryData.module_name = module.module_name;
    // console.log("module Data Updated:",this.CategoryData.module_name);
  // },
  },
  data() {
    return {
      formattedDescription:"",
      required,
      alphaNum,
      email,
      countries,
      searchQuery: "",
      showImage: false,
      removebutton: true,
      modules: [],
      CategoryData: {
        category_id:"",
        subject_id:"",
        category_name: "",
        category_img: "",
        order: "",
        video: {},
        module:{},
        description: null ,
      },
      table_data: {},
      orginal_name: "",
      edit_category_data: "",
      statusVideosModel: false,
      keyForLottie: 0,
    };
  },
  created() {
    // this.gettabledata();
  },
  computed: {
    formattedDescription: {
    get() {
      return this.CategoryData.description
        ? this.CategoryData.description.split(',').join('\n')
        : ''
    },
    set(val) {
      this.CategoryData.description = val.split('\n').join(',')
    }
  },
    submitbutton() {
      return !(
        this.CategoryData.category_name.length > 0 &&
        this.CategoryData.category_img.length > 0
      );
    },
  },
  methods: {
    isM3U8(url) {
    if (!url) return false;

    if (url.path) {
      url = url.path;
    }

    if (typeof url !== 'string') return false;

    return url.endsWith('.m3u8');
  },
    uuidv4,
    saveCategoryVideo(categoryVideo) {
      this.CategoryData.video = categoryVideo;

    },

    getFileExtensionFromUrl(url) {
      if (!url) return '';
      const path = url.split('?')[0].split('#')[0];
      const extension = path.split('.').pop();

      if (extension === path) return '';

      return extension;
    },


    showVideosModel() {
      this.statusVideosModel = true;
    },
    modelVideoClose() {
      this.statusVideosModel = false;
    },
    saveCategoryImage(categoryImage) {
      this.CategoryData.category_img = categoryImage;
      this.keyForLottie += 1;
    },
    modelClose(modelState) {
      this.showImage = modelState;
    },
    getImages() {
      if (this.searchQuery.trim().length > 0) {
        return this.table_data.filter((item) => {
          if (item.image_name) {
            return this.searchQuery
              .toLowerCase()
              .split(" ")
              .every((v) => item.image_name.toLowerCase().includes(v));
          }
        });
      } else {
        return this.table_data;
      }
    },
    gettabledata: function () {
      axios
        .get(process.env.VUE_APP_API_URL + "/zape-cms/gallery", {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("_t"),
          },
        })
        .then((get_response) => {
          // console.log(response.data);
          this.table_data = get_response.data;
          this.keyForLottie = this.keyForLottie + 1;
        });
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    resetForm() {
      this.CategoryData = {
        category_name: this.Editcategoryname,
        category_img: this.EditCategoryImage,
        order: this.editOrder,
        description:description  ?? null,
        showTitle:showTitle,

      };
      this.searchQuery = "";
      this.showImage = false;
      this.removebutton = true;
      this.validated = false;
    },
   

    onSubmit() {
      this.CategoryData.img_name = this.orginal_name["name"];
      // this.CategoryData.id = this.Editclassdata;
      // this.CategoryData.subject_id = this.Editsubjectid;
      // this.CategoryData.category_id = this.Editcategoryid;

      // if (this.CategoryData.description && typeof this.CategoryData.description === 'string') {
      //   this.CategoryData.description = this.CategoryData.description.split('\n').join(',');
      // } 

      if (typeof this.CategoryData.description === 'string') {
  this.CategoryData.description = this.CategoryData.description.split('\n').join(',');
} else {
  this.CategoryData.description = null;
}

      console.log("Submit Data:", this.CategoryData); 
      this.$emit("clickEditCategorydata", this.CategoryData);
    },
    showgalleryimage() {
      this.showImage = true;
      this.removebutton = false;
    },
    hideimagegallery() {
      this.showImage = false;
      this.removebutton = true;
    },
    galleryimg(data) {
      this.CategoryData.category_img = data;
      this.CategoryData.value = "1";
    },
    getFileExtension(mimeType) {
            const mimeToExtension = {
                'image/jpeg': 'jpg',
                'image/png': 'png',
                'image/gif': 'gif',
                'image/svg+xml': 'svg',
                '.svg': 'svg',
                'application/json': 'json',
                '.json': 'json',
                '.lottie': 'lottie',
                'lottie': 'lottie',
            };
            return mimeToExtension[mimeType] || 'png';
        },
        async uploadFile(file, url, key, ext) {
            try {
                const response = await axios.put(url, file, {
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': file.type,
                    },
                });

                if (response.status !== 200) {
                    console.error('Error uploading file:', response);
                }
                let s3Url = 'https://zape02.s3.ap-southeast-1.amazonaws.com/' + key;
                this.CategoryData.category_img= s3Url;
                this.CategoryData.value = 0;
                  this.keyForLottie += 1;
                // this.localKeyForLottie += 1;

            } catch (error) {
                this.isLoading = false;
                console.error('Error uploading file:', error);
            }
        },
    async inputImageRenderer(input) {
      if (input.target.files && input.target.files[0]) {
          const file = event.target.files[0];
            if (file) {
                this.isLoading = true;
                try {
                    const fileType = file.name.includes('.lottie') ? 'lottie'  : file.type;
                    const fileExtension = this.getFileExtension(fileType);
                    const response = await axios.post(process.env.VUE_APP_API_URL + '/s3/generate-presigned-url', {
                        type: file.type,
                        ext: fileExtension
                    }, {
                        headers: {
                            Authorization: "Bearer " + localStorage.getItem("_t"),
                        },
                    });
                    const { url, key } = response.data;
                    const extention = fileExtension == 'json' ? 'lottie' : fileExtension
                    await this.uploadFile(file, url, key, extention);
                } catch (error) {
                    this.isLoading = false;
                    console.error('Error getting pre-signed URL:', error);
                }
            }

        }
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
